import React, { type ReactNode } from "react";
import { Section, sectionSpacingY } from "components/section";
import { TextTitle } from "ui/text";
import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { MegaphoneIcon } from "ui/icons";
import { BulbSuggestionIcon, ContentIcon, ManagerIcon, MetricIcon, SyncIcon } from "./icons";

const ICON_SIZE = "icon.xl";

export function Teams() {
  const teamsConfig = [
    {
      id: "lifecycle-marketing",
      title: "Lifecycle marketing",
      icon: <SyncIcon />,
    },
    {
      id: "advertising",
      title: "Advertising",
      icon: <ContentIcon />,
    },
    {
      id: "media-sales",
      title: "Media sales",
      icon: <MegaphoneIcon boxSize={ICON_SIZE} />,
    },
    {
      id: "digital-experiences",
      title: "Digital experiences",
      icon: <BulbSuggestionIcon />,
    },
    {
      id: "customer-service",
      title: "Customer service",
      icon: <ManagerIcon />,
    },
    {
      id: "revenue-management",
      title: "Revenue management",
      icon: <MetricIcon />,
    },
  ];

  return (
    <Section my={0} pb={sectionSpacingY} display="flex" flexDir="column" alignItems="center" justifyContent="center">
      <Box
        bg="radial-gradient(232.33% 151.47% at 47.88% -24.42%, #E3FFF0 0%, #C1E9FF 100%)"
        py={{ base: "bigger", md: "80px" }}
        px={{ base: "small", md: "bigger" }}
        borderRadius="smaller"
      >
        <TextTitle
          size="md"
          mobileAlign="center"
          align="center"
          title="Agents can help in any marketing workflow across your business"
          mb={{ base: "bigger", md: "biggest" }}
        />

        <SimpleGrid
          columns={{ base: 3, md: 6 }}
          spacing={{ base: "40px", lg: "80px" }}
          alignItems="start"
          maxW="4xl"
          mx="auto"
        >
          {teamsConfig.map((team) => (
            <TeamItem key={team.id} icon={team.icon} title={team.title} />
          ))}
        </SimpleGrid>
      </Box>
    </Section>
  );
}

function TeamItem({ icon, title }: { icon: ReactNode; title: string }) {
  const bgColor = "radial-gradient(55.42% 55% at 50.25% 55%, #F7FCFF 0%, #D4EEFF 100%)";

  return (
    <Flex flexDir="column" alignItems="center" justifyContent="center" gap="smaller">
      <Flex
        align="center"
        justify="center"
        boxSize="biggest"
        borderRadius="20px"
        border="3px solid white"
        color="new.blue.900"
        bg={bgColor}
        boxShadow="md"
      >
        {icon}
      </Flex>

      <Text fontSize="14px" fontWeight="semibold" textAlign="center" maxW="huge" lineHeight={1.3}>
        {title}
      </Text>
    </Flex>
  );
}
